import React, { useState } from "react";
import Box from "@mui/material/Box";
import TemplateAnalytics from "../TemplateAnalytics/TemplateAnalytics";
import BotbridgeAnalytics from "../UserEngagementOverview/BotbridgeAnalytics";
import ReachFrequencyReport from "../ReachFrequencyReport/ReachFrequencyReport";
import CampaignAnalyticsReport from "../CampaignAnalytics/CampaignAnalyticsReport";
import CustomTabs from "../../common/custom-tabs";

// Combines two previously-separate menu items (Template Analytics, User
// Engagement) into one page with tabs. Each tab's visibility is still gated
// by its own original permission -- no change to who can see what, just
// where it's reachable from. Structure mirrors Logs/Logs.jsx (LogsDashboard)
// for consistency.
const WhatsAppAnalyticsTab = (props) => {
  const permissionsFromStorage = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasTemplateAnalytics = permissionsFromStorage.includes("template_analytics.view");
  const hasUserEngagement = permissionsFromStorage.includes("user_engagement_overview.view");

  const allTabs = [
    { label: "Template Analytics Report", value: 0, show: hasTemplateAnalytics },
    { label: "User Engagement Report", value: 1, show: hasUserEngagement },
    { label: "Reach & Frequency Report", value: 2, show: true },
    { label: "Campaign Analytics Report", value: 3, show: true },
  ];
  const tabs = allTabs.filter((tab) => tab.show !== false);

  const [currentTab, setCurrentTab] = useState(tabs[0]?.value ?? 0);

  const handleTabsChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          pt: 5,
          px: 3,
          backgroundColor: "#F7F7F7",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <CustomTabs
            value={currentTab}
            onChange={handleTabsChange}
            tabs={tabs}
            inactiveBgColor="#E8EAED"
            backgroundColor="#E8EAED"
          />
        </Box>

        {currentTab === 0 && hasTemplateAnalytics && <TemplateAnalytics {...props} />}
        {currentTab === 1 && hasUserEngagement && <BotbridgeAnalytics {...props} />}
        {currentTab === 2 && <ReachFrequencyReport {...props} />}
        {currentTab === 3 && <CampaignAnalyticsReport {...props} />}
      </Box>
    </div>
  );
};

export default WhatsAppAnalyticsTab;
